import React, { useEffect, useState } from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import '../styles/SubscriptionPlanChart.css';

// Registrar los componentes necesarios para Chart.js
ChartJS.register(ArcElement, Tooltip, Legend);

const SubscriptionPlanChart = ({ subscriptions }) => {
  const [chartData, setChartData] = useState({
    labels: ['Trial', 'Personal', 'Negocio'],
    datasets: [
      {
        data: [0, 0, 0],
        backgroundColor: [
          'rgba(255, 206, 86, 0.7)',  // Amarillo para Trial
          'rgba(54, 162, 235, 0.7)',  // Azul para Personal
          'rgba(75, 192, 192, 0.7)',  // Verde para Negocio
        ],
        borderColor: [
          'rgba(255, 206, 86, 1)',
          'rgba(54, 162, 235, 1)',
          'rgba(75, 192, 192, 1)',
        ],
        borderWidth: 1,
      },
    ],
  });

  useEffect(() => {
    if (subscriptions && subscriptions.length > 0) {
      // Contar suscripciones por tipo
      const planCounts = {
        trial: 0,
        personal: 0,
        negocio: 0
      };

      subscriptions.forEach(subscription => {
        const planType = subscription.type_subscript?.toLowerCase() || 'trial';
        if (planType === 'trial') {
          planCounts.trial += 1;
        } else if (planType === 'personal') {
          planCounts.personal += 1;
        } else if (planType === 'negocio') {
          planCounts.negocio += 1;
        }
      });

      // Actualizar los datos del gráfico
      setChartData({
        ...chartData,
        datasets: [
          {
            ...chartData.datasets[0],
            data: [planCounts.trial, planCounts.personal, planCounts.negocio],
          },
        ],
      });
    }
  }, [subscriptions]);

  // Opciones para el gráfico de media dona
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom',
        labels: {
          font: {
            size: 14
          }
        }
      },
      tooltip: {
        callbacks: {
          label: function(context) {
            const label = context.label || '';
            const value = context.raw || 0;
            const total = context.dataset.data.reduce((a, b) => a + b, 0);
            const percentage = Math.round((value / total) * 100);
            return `${label}: ${value} (${percentage}%)`;
          }
        }
      },
      title: {
        display: true,
        text: 'Distribución de Usuarios por Plan',
        font: {
          size: 18
        }
      }
    },
    circumference: 180,
    rotation: -90,
  };

  return (
    <div className="subscription-plan-chart-container">
      <h3>Distribución de Usuarios por Plan</h3>
      <div className="chart-wrapper">
        <Doughnut data={chartData} options={options} />
      </div>
      <div className="chart-legend">
        <div className="legend-item">
          <div className="legend-color" style={{ backgroundColor: 'rgba(255, 206, 86, 0.7)' }}></div>
          <div className="legend-label">Trial: {chartData.datasets[0].data[0]}</div>
        </div>
        <div className="legend-item">
          <div className="legend-color" style={{ backgroundColor: 'rgba(54, 162, 235, 0.7)' }}></div>
          <div className="legend-label">Personal: {chartData.datasets[0].data[1]}</div>
        </div>
        <div className="legend-item">
          <div className="legend-color" style={{ backgroundColor: 'rgba(75, 192, 192, 0.7)' }}></div>
          <div className="legend-label">Negocio: {chartData.datasets[0].data[2]}</div>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionPlanChart;
